<template>
    <div class="aboutUs-news">
        <div class="banner">
            <div class="banner-center center">
                <div class="banner-info">
                    <div class="btn shenqing bgRed" @click="openDialog('免费试用',0)">申请试用</div>
                </div>
            </div>
        </div>
        <div class="item_1">
            <div class="item-contents center">
               <ul style="margin-bottom: 100px;">
                   <li class="clearfix" v-for="(x,index) in item1_list" @click="toNewsDetail(x)">
                        <div class="image">
                            <img :src="x.bigImg" alt="">
                        </div>
                        <div class="info">
                            <h4 class="title">{{x.title}}</h4>
                            <p>{{x.introduction}}</p>
                            <div class="date">{{x.creatTime}}</div>
                        </div>
                   </li>
               </ul>
               <a-pagination :pageSize='pageSize' v-model="pageIndex"  :total="pageTotal" :item-render="itemRender"  @change="onChange" show-less-items ></a-pagination>
            </div>
        </div>
        <shen-qing></shen-qing>
    </div>
</template>

<script>
import shenQing from "./shenqing.vue";

export default {
    components: {
        shenQing,
    },
    metaInfo: {
        title: '培训学校管理系统_艺术培训机构软件_培训机构crm_艺术中心教务系统_教培行业系统软件_易知鸟官网',
        meta: [
        {
            name: 'keywords',
            content: '培训学校管理系统,培训学校管理软件,艺术培训管理系统,培训行业管理软件,培训班管理系统,辅导班管理软件,培训机构管理系统,教育培训管理软件,培训机构crm,学员管理系统"'
        },
        {
            name: 'description',
            content: '易知鸟为教育培训行业提供招生营销、运营ERP（学员、排课、教务）、CRM客户管理系统、跨校区管理、家校服务、日常课务、扫码收银、财务统计等，一站式为培训学校与机构提供SaaS服务。'
        },
        {
            property:'og:type',
            content:'培训学校管理系统,培训学校管理软件,艺术培训管理系统,培训行业管理软件,培训班管理系统,辅导班管理软件,培训机构管理系统,教育培训管理软件,培训机构crm,学员管理系统'
        },
        ],
    },
    data(){
        return{
            current:1,
            pageIndex:1,
            pageSize:5,
            pageTotal:0,
            item1_list:[],
        }
    },
    created(){
        // this.getList();
    },
    mounted(){
        this.getList();
    },
    methods:{
      openDialog:function(title,type){//type:(0机构,1微官网)
            this.$parent.$refs.openPop.openDialog(title,type);
        },
        itemRender(current, type, originalElement) {
            if (type === 'prev') {
                return <a>上一页</a>;
            } else if (type === 'next') {
                return <a>下一页</a>;
            }
            return originalElement;
        },
        onChange(current) {
            this.pageIndex = current;
            this.getList();
        },
        getList(){
            var this_ = this;
            var start_ = (this.pageIndex-1)*this_.pageSize;
            $.ajax({
                    url: this_.CONFIG.URL + '/api/admin/contents/list',
                    type: "get",
                    data:{start:start_,count:5},
                    success: function (data) {
                        this_.$nextTick(()=>{
                            if (data.status == '200') {
                                this_.item1_list = data.context.items;
                                this_.pageTotal = data.context.totalNum;
                            }
                        });
                    },
                    error:function(data){
                        this_.$nextTick(()=>{
                            this_.$notification['error']({
                                message: '提示',
                                description:'网络异常,请稍后再试',
                                style: {
                                    position:'fixed',
                                    top:'50%',
                                    left:'50%'
                                },
                            });
                        });
                    }

                });
        },
        toNewsDetail(x){
            this.$router.push({
                    path: "/newsDetail",
                    query: {
                        contentsId:x.contentsId
                    }
                });
                localStorage.setItem("contentsId",this.$route.query.contentsId);
        }
    }
}
</script>

<style scoped lang="less">

.banner {
        width: 100%;
        height: 480px;
        margin-top: 80px;
        background: url("https://cdntest.yizhiniao.com/newWebsite_/aboutUs_news/guanyu_hangye_banner.jpg") no-repeat center;

        .banner-center {
            height: 100%;
            position: relative;
        }

        .banner-info {
            position: absolute;
            bottom: 120px;
            left: 40px;
            text-align: left;
        }
    }
    .item_1{
        padding:180px 0;
        .item-contents{
            ul{
                li{
                    margin-top:100px;
                    &:first-child{
                        margin-top: 0;
                    }
                    .image{
                        float: left;
                        width: 300px;
                        height: 180px;
                        overflow: hidden;
                        img{
                            width:100%;
                        }
                    }
                    .info{
                        float: left;
                        margin-left:20px;
                        width: 840px;
                        &:hover{
                            .title{
                                font-weight: 600;
                            }
                            p{
                                color: #1E1E1E;
                            }
                        }
                        .title{
                            text-align: left;
                            font-size: 26px;
                            font-weight: 400;
                            color: #1E1E1E;
                            line-height: 37px;
                            margin-bottom:10px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            cursor: pointer;
                        }
                        p{
                            font-size: 16px;
                            font-weight: 400;
                            color: #646464;
                            line-height: 22px;
                            text-align: left;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 3;
                            overflow: hidden;
                            cursor: pointer;
                        }
                        .date{
                            font-size: 16px;
                            font-weight: 400;
                            color: #646464;
                            line-height: 22px;
                            text-align: right;
                            margin-top: 44px;
                        }
                    }
                }
            }
            .page{
                margin-top: 100px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/aboutUs_news.vue